var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"model-status-label",class:{'blue': _vm.modelStatusLabel === 'Published'}},[_vm._v("\n    "+_vm._s(_vm.modelStatusLabel)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }